import React, {Component} from "react";
import {TouchableOpacity, View, Text, FlatList, Platform} from "react-native";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import {moderateScale} from "../../../../tools/Scaling";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import {KeyboardAvoidingView} from "./ListReport15RequestScreen";
import HMImageView from "../../../../customviews/HMImageView";

export default class DetailsListTaskReportScreen extends Component {
    render() {
        const {text, textStyle, textType, style, type, borderRadius, height, onPress, results} = this.props;
        let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;
        return (
            <View style={{
                flex: 1,


            }}>
                {
                    this.props.item ?
                        null
                        :
                        <HMActionBarSatia
                            //exit={true}
                            menu
                            back

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListServiceHistorySatia.title')}
                            text={(item && item.name ? item.name : (item && item.title ? item.title : 'جزئیات'))}
                            //text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}


                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                }
                <View
                    style={{
                    style: 1,
                    overflow: 'hidden',
                    //   height: HeightItem,
                    // padding: moderateScale(4),
                    //  margin:moderateScale(5),
                    borderWidth: moderateScale(1),
                    borderRadius: moderateScale(2),
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000',
                    shadowOffset: {width: 0, height: moderateScale(.7)},
                    shadowOpacity: 0.6,
                    shadowRadius: moderateScale(2),
                    elevation: moderateScale(1),
                    margin: moderateScale(4),
                    padding: moderateScale(4),
                    // marginLeft: moderateScale(1),
                    // marginRight: moderateScale(1),
                    // marginTop: moderateScale(1),
                    // marginBottom: moderateScale(1),
                    backgroundColor: Colors.white,
                }}>
                    <View
                        style={{ margin: moderateScale(6), alignItems: "center",}}>
                        {
                            !item.image ?
                                null
                                :
                                <View style={{width: moderateScale(48), height: moderateScale(48), marginBottom:moderateScale(10)}}>
                                    <HMImageView
                                        // resizeMode={FastImage.resizeMode.contain}
                                        resizeMode={"contain"}
                                        _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                        //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                        uriComplete={item.image}
                                        //source_image={item.image}
                                        styleText={{marginTop: moderateScale(10)}}
                                        borderRadius={4}/>

                                </View>
                        }

                        <HMTextView
                            // numberOfLines={2}
                            type={"bold"}
                            //text={item.subject}
                            text={item && item.label ? item.label : ""}
                            style={{
                                fontSize: moderateScale(14),

                                color: Colors.blackLight,
                                marginHorizontal: moderateScale(6),
                                //  textAlign: "right",
                            }}/>
                    </View>
                    <FlatList
                        data={item && item.list ? item.list : []}

                        renderItem={({item, index}) => {

                            return <View
                                style={{
                                    //width: "100%",
                                    flex: 1,
                                    flexDirection: "row",
                                    marginVertical: moderateScale(4),
                                    // overflow: 'hidden',
                                    // //   height: HeightItem,
                                    // // padding: moderateScale(4),
                                    // //  margin:moderateScale(5),
                                    // borderWidth: moderateScale(1),
                                    // borderRadius: moderateScale(2),
                                    // borderColor: '#ddd',
                                    // borderBottomWidth: 0,
                                    // shadowColor: '#000',
                                    // shadowOffset: {width: 0, height: moderateScale(.7)},
                                    // shadowOpacity: 0.6,
                                    // shadowRadius: moderateScale(2),
                                    // elevation: moderateScale(1),
                                    // margin: moderateScale(4),
                                    // padding: moderateScale(4),
                                    // // marginLeft: moderateScale(1),
                                    // // marginRight: moderateScale(1),
                                    // // marginTop: moderateScale(1),
                                    // // marginBottom: moderateScale(1),
                                    // backgroundColor: Colors.white,
                                }}>

                                <HMTextView
                                    // numberOfLines={2}
                                    type={"bold"}
                                    //text={item.subject}
                                    text={` - ${(index + 1)}`}
                                    style={{
                                        fontSize: moderateScale(13),

                                        color: Colors.colorDarkText
                                        //  marginTop: moderateScale(4),
                                        //  textAlign: "right",
                                    }}/>

                                <HMTextView
                                    // numberOfLines={2}
                                    type={"bold"}
                                    //text={item.subject}
                                    text={item && item.label ? item.label : ""}
                                    style={{
                                        fontSize: moderateScale(13),

                                        color: Colors.colorDarkText
                                        //  marginTop: moderateScale(4),
                                        //  textAlign: "right",
                                    }}/>


                            </View>

                        }}
                        keyExtractor={(item, index) => index.toString()}
                        ListEmptyComponent={() =>
                            null}
                        // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                        //  ListFooterComponent={this.renderFooter.bind(this)}
                        // refreshing={this.props.showRefresh}
                        // onRefresh={this.handleRefresh.bind(this)}
                        // onEndReached={this.handleLoadMore.bind(this)}
                        // initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                        // getItemLayout={(data, index) => ({
                        //     length: moderateScale(85),
                        //     offset: moderateScale(85) * index,
                        //     index
                        // })}
                        // initialNumToRender={5}
                        // maxToRenderPerBatch={10}
                        // windowSize={10}
                    />
                </View>
            </View>
        );
    }
}
